import { CrmObjectBoardCard } from 'crm-object-board-card';
import { useCardPerformance } from './hooks/useCardPerformance';
import { useHandlers } from '../handlers/useHandlers';
import { useHasBulkActions } from '../bulkActions/hooks/useHasBulkActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CardComponentV2 = cardData => {
  const hasBulkActions = useHasBulkActions();
  const {
    cardRef,
    renderCardLoadedMarker
  } = useCardPerformance();
  const handlers = useHandlers();
  return /*#__PURE__*/_jsxs("div", {
    ref: cardRef,
    children: [renderCardLoadedMarker && renderCardLoadedMarker(), /*#__PURE__*/_jsx(CrmObjectBoardCard, {
      cardData: Object.assign({}, cardData, {
        SelectionCheckbox: hasBulkActions ? cardData.SelectionCheckbox : undefined,
        hasSelectionCheckbox: hasBulkActions && cardData.hasSelectionCheckbox,
        onPreviewClick: handlers.onCardClick
      })
    })]
  });
};